import { Stack, TextField, Button, FormControl, InputLabel, Select, Divider, MenuItem, CircularProgress } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../../redux/api';
import { newTemplateActions } from '../../../../redux/slices/newTemplateSlice';

function NtwEdiSefTemplate() {
  const { t } = useTranslation();
  const [sefFileVal, setSefFileVal] = useState('')
  const [isSefValid, setIsSefValid] = useState(false);
  const [loading, setLoading] = useState(false)
  const [ediSet, setEDISet] = useState('');
  const [ediSetOptions, setEdiSetOptions] = useState([])
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.queryParams)
  const error = useRef();
  const fileBrowser = useRef();
  const { EDISefTemplateData: data } = useSelector((state) => state.newTemplate)

  const handleUploadClick = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSefFileVal(file.name);
    const fileNameWithoutExtension = file.name.split(".") .slice(0, -1) .join(".");

    let fileInfo = "";
    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        fileInfo = e.target.result;
      };
      reader.readAsText(file);
      setLoading(true);
      let formData = new FormData();
      formData.append("file", file);
      const response = await dispatch(api.endpoints.getEDISet.initiate({
          account: account,
          data: formData,
        }));

      if (response.error) {
        throw new Error(response.error.message || t("BOX_MSG_GENERAL_ERROR"));
      }

      if (response?.data.current_state === "SUCCESS") {
        setLoading(false);
        let ediSet = response.data.data[0].title;
        let releaseKey = response.data.data[0].release_key;
        setIsSefValid(true);
        setEdiSetOptions(response.data.data);
        setEDISet(ediSet);
        dispatch(
          newTemplateActions.setEDISefTemplateData({
            fileInfo,
            sefEdiSet: ediSet,
            release_key: releaseKey,
          })
        );
        dispatch(newTemplateActions.setTemplateName(fileNameWithoutExtension));
      } else {
        setLoading(false)
        error.current.textContent = response.data.message;
        dispatch(newTemplateActions.setEDISefTemplateData(""));
        dispatch(newTemplateActions.setTemplateName(""));
      }
    } catch (err) {
      setLoading(false);
      error.current.textContent = err.message || "An unknown error occurred";
    }
  };
  const handleChange = (key, e) => {
    if (key === "EDI_SET") {
      dispatch(
        newTemplateActions.setEDISefTemplateData({
          ...data,
          sefEdiSet: e.target.value,
        })
      );
    }
  };
  const handleMenuItemClick = (key) => {
    dispatch(
      newTemplateActions.setEDISefTemplateData({ ...data, release_key: key })
    );
  };
  const ediSetDropdownOption = ediSetOptions?.map((option, key) => (
    <MenuItem
      key={key}
      value={option.title}
      onClick={() => handleMenuItemClick(option.release_key)}
    >{`${option.title} - ${option.description}`}</MenuItem>
  ));
  useEffect(() => {
    dispatch(newTemplateActions.setIsFormData(true))
  }, [])
  return (
    <>
      <Stack spacing={'8px'}>
        <div className='flex'>
          <TextField
            className='width-100'
            label={t('CHOOSE_SEF_FILE')}
            variant='outlined'
            size='small'
            value={sefFileVal}
            onChange={(e) => {
              error.current.textContent = ""
            }}
          />
          <input
            style={{ display: "none" }}
            type="file"
            ref={fileBrowser}
            onChange={(e) => {
              // setSefFileVal(e.target.value);
              error.current.textContent = "";
              setEDISet('');
              setIsSefValid(false);
              handleUploadClick(e);
            }}
          />
          <Button
            variant="outlined"
            size="small"
            disableElevation
            className="margin-left-4"
            disabled={loading}
            sx={{
              width: "40px",
              padding: "4px 8px",
              minWidth: "40px",
            }}
            onClick={() => {
              fileBrowser.current.click();
            }}>
           {loading ? <CircularProgress color='primary' size='20px' /> : <DriveFolderUploadIcon fontSize="small" />}
          </Button>
        </div>
        <div>
          <p className="error" ref={error}></p>
        </div>
        <FormControl size="small" variant="outlined">
          <InputLabel id="validationDropdownLabel">
            {t("LBL_EDI_SET")}
          </InputLabel>
          <Select
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 280,
                },
              },
            }}
            className="width-100"
            labelId="validationDropdownLabel"
            id="validationDropdown"
            disabled={!isSefValid}
            value={ediSet}
            onChange={(e) => {
              setEDISet(e.target.value);
              handleChange("EDI_SET", e);
            }}
            label={t("LBL_EDI_SET")}>
            {ediSetDropdownOption}
          </Select>
        </FormControl>
      </Stack>
    </>
  )
}

export default NtwEdiSefTemplate